﻿cb.define([], function () {
	var ST_st_storenotice_VM_Extend = {
		doAction: function (name, viewmodel) {
			if (this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {
			let gridModel = viewmodel.getGridModel();
			gridModel.on('afterSetDataSource', () => {
				const rows = gridModel.getRows();
				const actions = gridModel.getCache('actions');
				const actionsStates = [];
				rows.forEach(data => {
					const actionState = { };
					actions.forEach(action => {
						actionState[action.cItemName] = { visible: true };
						if (data.bizstatus != "0") {
							actionState["btnClose"] = { visible: false };
							actionState["btnStoreIn"] = { visible: false };
						}
						if (data.bizstatus == "2") {
							actionState["btnOpen"] = { visible: true };	
						}else{
							actionState["btnOpen"] = { visible: false };	
						}
					  });
					actionsStates.push(actionState);
				});
				gridModel.setActionsState(actionsStates);
			})
		}
	}

	try {
		module.exports = ST_st_storenotice_VM_Extend;
	} catch (error) {

	}
	return ST_st_storenotice_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storenoticelist_VM.Extend.js